export const DEFAULT_THEME_ACCENT = "#2563eb";

const HEX_PATTERN = /^#[0-9A-Fa-f]{6}$/;

export function normalizeAccentColor(value: string | null | undefined): string | null {
  if (!value) return null;
  const trimmed = value.trim();
  if (!HEX_PATTERN.test(trimmed)) return null;
  return trimmed.toLowerCase();
}
